export default {
  columns: {
    strategy: 'Strategie',
    source: 'Quelle',
    async: 'Asynchron',
    content: 'Inhalt',
    edit: 'Bearbeiten',
    delete: 'Löschen',
  },
  buttons: {
    add_script: 'Script hinzufügen',
  },
};
